import CustomPhotoPicker from "../../../../../components/PhotoPicker/CustomPhotoPicker";
import { SUGGESTION_MODE_OPTION } from "../../../../../components/PhotoPicker/SubComponent/Models/Models";
import StepperTabs from "../../../../../components/StepperTabs/StepperTabs";
import StepTab from "../../../../../components/StepperTabs/StepTab";
import { ACTION_MODEL } from "../../../../../Helpers/ActionModel";
import { FILE_TYPE } from "../../../../../Helpers/fileType";
import AccessRights from "../../../Company/Employees/AccessRightsSection/AccessRights";
import Step2OtherDetails from "../../../Company/Employees/EnrollmentSteps/Step2OtherDetails";
import { STEPS_CONTRACTOR_UPDATE } from "../../Model/Models";
import ContractorCompanyFields from "./ContractorCompanyFields";
import ManagerFields from "./ManagerFields";
/**
 * @Author      Susana García Rodríguez
 * @JobTitle    Frontend Developer
 * @Email       sgarcia@ibl.mx
 */

const ContractorStepperWithDetails = ({
    user,
    setUser,
    steps,
    activeStep,
    setActiveStep,
    handleStepChange,
    emptyFields,
    getAllServiceType,
    extraData,
    setExtraData,
    headersList,
    handleChange,
    isValidDocumentId,
    setIsValidDocumentId,
    isValidEmail,
    isValidPhoneNumber,
    isValidDob,
    setIsValidDob,
    handleEmailChange,
    handlePasswordChange,
    handlePhoneNumberChange,
    handleDateChange,
    userInfoStatusList,
    photoPicker,
    setPhotoPicker,
    disabled,
    workShiftsList,
    setWorkShiftsList,
    customizedList,
    setCustomizedList,
    params
}) => {
    return (
        <StepperTabs
            id={user?.id}
            disabled={false}
            steps={steps}
            activeStep={activeStep}
            isStepOptional={(step) => step === STEPS_CONTRACTOR_UPDATE.OTHER_DETAILS}
            setActiveStep={setActiveStep}
            handleStepChange={handleStepChange}
        >
            <StepTab index={STEPS_CONTRACTOR_UPDATE.COMPANY_DETAILS} activeStep={activeStep} normalHeight>
                <ContractorCompanyFields
                    user={user}
                    setUser={setUser}
                    emptyFields={emptyFields}
                    getAllServiceType={getAllServiceType}
                />
            </StepTab>
            <StepTab index={STEPS_CONTRACTOR_UPDATE.MANAGER_DETAILS} activeStep={activeStep} normalHeight>
                <ManagerFields
                    title="manager"
                    user={user}
                    setUser={setUser}
                    emptyFields={emptyFields}
                    isValidDocumentId={isValidDocumentId}
                    setIsValidDocumentId={setIsValidDocumentId}
                    isValidEmail={isValidEmail}
                    isValidPhoneNumber={isValidPhoneNumber}
                    isValidDob={isValidDob}
                    setIsValidDob={setIsValidDob}
                    handleEmailChange={handleEmailChange}
                    handlePasswordChange={handlePasswordChange}
                    handlePhoneNumberChange={handlePhoneNumberChange}
                    handleDateChange={handleDateChange}
                    statusList={userInfoStatusList}
                />
            </StepTab>
            <StepTab index={STEPS_CONTRACTOR_UPDATE.OTHER_DETAILS} activeStep={activeStep} normalHeight>
                <Step2OtherDetails
                    showBtnClean={user}
                    extraData={extraData}
                    onChange={handleChange}
                    setExtraData={setExtraData}
                    headersList={headersList}
                />
            </StepTab>
            <StepTab index={STEPS_CONTRACTOR_UPDATE.ADD_PHOTO} activeStep={activeStep} normalHeight>
                <CustomPhotoPicker
                    id="fp_ce_update_photo_profile"
                    photoPicker={photoPicker}
                    setPhotoPicker={setPhotoPicker}
                    actionModel={ACTION_MODEL.UPDATE}
                    accept={{ ...FILE_TYPE.IMAGE_FACE_VALIDATION }}
                    showBtnCamera
                    validateFace
                    classWith="w-400px"
                    showPreview
                    disabled={disabled}
                    titleModalEdit="update_photography"
                    typeSuggestions={SUGGESTION_MODE_OPTION.SELFIE}
                />
            </StepTab>

            <StepTab index={STEPS_CONTRACTOR_UPDATE.ACCESS_RIGHT} activeStep={activeStep} normalHeight>
                <AccessRights
                    workShiftsList={workShiftsList}
                    setWorkShiftsList={setWorkShiftsList}
                    customizedList={customizedList}
                    setCustomizedList={setCustomizedList}
                    user={user}
                    contractorItemId={params?.id}
                    isEditable
                />
            </StepTab>
        </StepperTabs>
    );
};
export default ContractorStepperWithDetails;